import { HomeGroupMinusIcon } from './HomeGroupMinusIcon';

/**
 * author: Michael Irigoyen
 * id 786A8373-A89F-4905-9698-B8AD3CF4D230
 * name home-group-minus
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-group-minus.svg
 * tags
 * - Home Automation 
 */
export const HouseGroupMinusIcon = HomeGroupMinusIcon;
export default HouseGroupMinusIcon